var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "item-spinner d-flex justify-content-center" },
            [
              _c("ob1-progress-indicators", {
                attrs: { size: 50, type: "undetermined" },
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "pt-1", attrs: { id: "addAccessoryCta" } },
            [
              _c("ob1-boutons", {
                ref: "add-accessory-cta",
                attrs: {
                  label: _vm.accessory.currentVersion.boutonsDTO.label,
                  "is-primary": true,
                  "is-disabled": !_vm.isAddButtonEnabled,
                },
                on: { "ob1-boutons-click": _vm.onAddAccessoryButtonClick },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "ob1-popin-modal2",
        {
          attrs: {
            id: _vm.accessory.addToCartDTO.popinModalDTO.id,
            "aria-labelledby": _vm.accessory.addToCartDTO.popinModalDTO.label,
            "show-close-button": false,
          },
        },
        [
          _c("h3", { staticClass: "h4" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.accessory.addToCartDTO.popinTitle) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center justify-content-md-start",
            },
            [
              _c(
                "div",
                { staticClass: "d-flex flex-column" },
                [
                  _c("ob1-boutons", {
                    staticClass: "my-2",
                    attrs: {
                      "data-bs-dismiss": "modal",
                      label: _vm.accessory.addToCartDTO.continueShopping,
                      "is-secondary": true,
                    },
                  }),
                  _vm._v(" "),
                  _c("ob1-boutons", {
                    attrs: {
                      label: _vm.accessory.addToCartDTO.liensDTO.text,
                      href: _vm.cartUrl,
                      "is-button": false,
                      "is-primary": true,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }